module.exports = __webpack_public_path__ + "50537c7da3aca4d2e093adf3f722adcf.jpg";